module.exports = __webpack_public_path__ + "img/export-icon.ea895d8a.svg";